export enum Environments {
  PRODUCTION = 'production',
  DEMO = 'demo',
  PREPROD = 'preprod',
  STAGING = 'staging',
  DEVELOPMENT = 'development'
}
